import { createI18n } from 'vue-i18n'
import dayjs from 'dayjs'
import type { UserModule } from '@/types'
import { DEFAULT_LOCALE, type LocaleCode } from '@/types/i18n'
import 'dayjs/locale/nl'
import 'dayjs/locale/en'

import messages from '@intlify/unplugin-vue-i18n/messages'

export const i18n = createI18n({
  allowComposition: true,
  globalInjection: true,
  legacy: false,
  locale: DEFAULT_LOCALE,
  fallbackLocale: 'nl',
  messages,
  numberFormats: {
    nl: {
      currency: {
        style: 'currency',
        currency: 'EUR',
        notation: 'standard',
      },
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
      percent: {
        style: 'percent',
        useGrouping: false,
      },
    },
    en: {
      currency: {
        style: 'currency',
        currency: 'EUR',
        notation: 'standard',
      },
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
      percent: {
        style: 'percent',
        useGrouping: false,
      },
    },
  },
})

export const setI18nLanguage = (locale: LocaleCode): void => {
  i18n.global.locale.value = locale
  dayjs.locale(locale)
  document.querySelector('html')?.setAttribute('lang', locale)
}

export const install: UserModule = (app) => {
  // Set initial locale from localStorage if available
  const savedLocale = localStorage.getItem('locale-preference')
  let initialLocale: LocaleCode = DEFAULT_LOCALE

  if (savedLocale) {
    try {
      const parsed = JSON.parse(savedLocale)
      if (parsed && (parsed.locale === 'nl' || parsed.locale === 'en')) {
        initialLocale = parsed.locale
      }
    } catch {
      // If parsing fails, use default locale
    }
  }

  setI18nLanguage(initialLocale)
  app.use(i18n)
}
